<template>
    <fragment>
        <td>
            <div class="status-wrap d-flex align-items-center justify-content-center">
                <span :class="'status ' + checkStatus"></span>
                <span v-if="activity && activity.status !== 'OK'" v-text="activity.status" class="bottom-small-stat"></span>
            </div>
        </td>
        <td v-if="hasDropdown">
            <div class="d-flex align-items-center" v-if="activity && (activity.activity == 'SW' || activity.activity == 'TC')">
                <div class="group-box">
                    <button :class="'group-btn ' + [activity.is_source == 1 ? 'is-source' : '']" @click="openDropdown" v-if="activity.group_number" v-text="pad(activity.group_number)"></button>
                    <button class="group-btn no-group" @click="openDropdown" v-else>??</button>
                    <ul v-show="dropDownActive === activity.activity + '-' + index" class="group-list">
                        <li><button @click="incrementGroupNumber" class="new-group">New group</button></li>
                        <li v-if="activity.group_number"><button @click="removeGroup" class="remove-group">Remove</button></li>
                        <li v-for="i in groupNumber" :key="i">
                            <button @click="changeGroup((groupNumber + 1) - i)" v-text="pad((groupNumber + 1) - i)"></button>
                        </li>
                    </ul>
                </div>
            </div>
        </td>    
    </fragment>     
</template>


<script>
    import {mapActions, mapState} from 'vuex';

    export default {
        props: ['index', 'activity', 'groupNumber', 'hasDropdown'],
        data() {
            return {
                isActive: false
            }
        },
        computed: {
            ...mapState(['dropDownActive']),
            checkStatus() {
                if (!this.activity) {
                    return 'not-doing';
                }

                if ((this.activity.activity == 'SW' || this.activity.activity == 'TC') && !this.activity.group_number) {
                    return 'not-assigned';
                }

                if(!this.activity.parent) {
                    if (this.activity.is_uploading == 0) {
                        return 'waiting';
                    }

                    if (this.activity.is_uploading == 1 && this.activity.notification_sent == 0) {
                        return 'processing';
                    }

                    if (this.activity.is_uploading == 1 && this.activity.notification_sent == 1) {
                        return 'uploaded';
                    }
                } else {
                    if (this.activity.parent.is_uploading == 0) {
                        return 'waiting';
                    }

                    if (this.activity.parent.is_uploading == 1 && this.activity.parent.notification_sent == 0) {
                        return 'processing';
                    }

                    if (this.activity.parent.is_uploading == 1 && this.activity.parent.notification_sent == 1) {
                        return 'uploaded';
                    }
                }
            }
        },
        methods: {
            incrementGroupNumber() {
                let newGroup;
                if(this.activity.activity == 'SW') {
                    this.$store.dispatch('incrementGroup', {
                        data: 'setSWGroupNumber',
                        value: parseInt(this.$store.state.swGroupNumber) + 1
                    });
                    newGroup = this.$store.state.swGroupNumber;
                } else {
                    this.$store.dispatch('incrementGroup', {
                        data: 'setTCGroupNumber',
                        value: parseInt(this.$store.state.tcGroupNumber) + 1
                    });
                    newGroup = this.$store.state.tcGroupNumber;
                }
                this.changeGroup(newGroup);
            }, 
            changeGroup(groupNumber) {
                this.activity.group_number = groupNumber;
                this.isActive = !this.isActive;
                axios.post('/ap/activity/change-group', this.activity)
                    .then(({data}) => {
                        this.$store.commit('setSessions', data);
                        this.$emit('group-number-changed', groupNumber);
                    });
                this.$store.state.dropDownActive = null;
            },
            pad(n) {
                return (n < 10) ? ("0" + n) : n;
            },
            openDropdown() {
                if(this.$store.state.dropDownActive === null) {
                    this.$store.state.dropDownActive = this.activity.activity + "-" + this.index;
                } else {
                    if(this.isActive) {
                        this.$store.state.dropDownActive = null;
                    } else {
                        this.$store.state.dropDownActive = this.activity.activity + "-" + this.index;
                    }
                }

                this.isActive = !this.isActive;              
            },
            removeGroup() {
                this.activity.group_number = null;
                this.isActive = !this.isActive;
                axios.post('/ap/activity/remove-group', this.activity)
                    .then(({data}) => {
                        this.$store.commit('setSessions', data);
                    });
                this.$store.state.dropDownActive = null;
            }
        }
    }
</script>